//First number (2,3,4,5,6, 7) is positionId of template active
export const CATEGORIES_ORDER = {
    //Defender
    2:{
      //Passing
      10: 1,
      //Saving
      11: 5,
      //Defending
      12: 3,
      //Shooting
      13: 6,
      //Ball Handling
      14: 7,
      //Association
      15: 2,
      //Aerial
      16: 4,
      //Crosses
      60: 8,
      //Carries
      61: 9,
      //Turnovers
      63: 10,
      //Sequence Involvement
      64: 11,
      //OutPlay
      69: 12,
      //LineBreakingPasses
      70: 13,
      //PassUnderPressure
      71: 14,
      //BallReceived
      72: 15,
      //OnBallPressure
      73: 16,
      //SpatialCoverage
      74: 17,
      //OffBallPressure
      75: 18,
      //Distance
      77: 19,
      //Sprint
      78: 20,
      //Acceleration
      79: 21,
      //Speed
      80: 22,
      //LineBreakingCarries
      90: 23,
      //OnBallPressureReceived
      91: 24,
      //LineBreakingActions
      92: 25,
      //OffBallRuns
      93: 26
    },
    //FullBack
    3: {
      10: 1,
      11: 6,
      12: 4,
      13: 7,
      14: 3,
      15: 2,
      16: 5,
      60: 8,
      61: 9,
      63: 10,
      64: 11,
      69: 12,
      70: 13,
      71: 14,
      72: 15,
      73: 16,
      74: 17,
      75: 18,
      77: 19,
      78: 20,
      79: 21,
      80: 22,
      90: 23,
      91: 24,
      92: 25,
      93: 26
    },
    //Midfielder
    4: {
      10: 1,
      11: 6,
      12: 4,
      13: 7,
      14: 3,
      15: 2,
      16: 5,
      60: 8,
      61: 9,
      63: 10,
      64: 11,
      69: 12,
      70: 13,
      71: 14,
      72: 15,
      73: 16,
      74: 17,
      75: 18,
      77: 19,
      78: 20,
      79: 21,
      80: 22,
      90: 23,
      91: 24,
      92: 25,
      93: 26
    },
    //Winger
    5: {
      10: 6,
      11: 7,
      12: 4,
      13: 1,
      14: 2,
      15: 3,
      16: 5,
      60: 8,
      61: 9,
      63: 10,
      64: 11,
      69: 12,
      70: 13,
      71: 14,
      72: 15,
      73: 16,
      74: 17,
      75: 18,
      77: 19,
      78: 20,
      79: 21,
      80: 22,
      90: 23,
      91: 24,
      92: 25,
      93: 26
    },
    //Forward
    6: {
      10: 3,
      11: 7,
      12: 6,
      13: 1,
      14: 2,
      15: 4,
      16: 5,
      60: 8,
      61: 9,
      63: 10,
      64: 11,
      69: 12,
      70: 13,
      71: 14,
      72: 15,
      73: 16,
      74: 17,
      75: 18,
      77: 19,
      78: 20,
      79: 21,
      80: 22,
      90: 23,
      91: 24,
      92: 25,
      93: 26
    },
    //WingBack
    7: {
      10: 1,
      11: 6,
      12: 4,
      13: 7,
      14: 3,
      15: 2,
      16: 5,
      60: 8,
      61: 9,
      63: 10,
      64: 11,
      69: 12,
      70: 13,
      71: 14,
      72: 15,
      73: 16,
      74: 17,
      75: 18,
      77: 19,
      78: 20,
      79: 21,
      80: 22,
      90: 23,
      91: 24,
      92: 25,
      93: 26
    },
}

export default CATEGORIES_ORDER;
